<div class="collaboration-not-supported-page bs-enabled">
	<!-- Background decoration -->
	<div class="bg-decoration"></div>

	<div class="trial-content">
		<!-- Badge -->
		<div class="trial-badge">
			<i class="far fa-gift"></i>
			<span>Limited Time Offer</span>
		</div>

		<!-- Hero Section -->
		<div class="trial-hero">
			<h1 class="trial-title">
				Protect Your <span class="highlight">Microsoft 365</span> Collaboration
			</h1>
			<p class="trial-subtitle">
				Secure Teams, SharePoint, and OneDrive with real-time threat detection, automated quarantine, and data loss prevention
			</p>
		</div>

		<!-- CTA Button -->
		<div class="trial-cta-section cursor-pointer"
			 (click)="startFreeTrial()">
			<div class="trial-cta-btn flex-row gap-2 align-items-center text-white">
				<ng-container *ngIf="!startingTrial">
					<i class="far fa-rocket"></i>
					<span>Start Your Free Trial</span>
				</ng-container>
				<div class="loading-spinner" style="border-color: white; height: 30px; width: 30px;" *ngIf="startingTrial"></div>
			</div>
			<span class="trial-cta-note">No credit card required</span>
		</div>

		<!-- Features Grid -->
		<div class="trial-features">
			<div class="feature-card">
				<div class="feature-icon shield-icon">
					<i class="fas fa-shield-alt"></i>
				</div>
				<h3>Microsoft 365 Protection</h3>
				<p>Comprehensive security for Teams, SharePoint, and OneDrive. Scan every file and link shared across your collaboration ecosystem in real time.</p>
			</div>

			<div class="feature-card">
				<div class="feature-icon scan-icon">
					<i class="fas fa-search"></i>
				</div>
				<h3>Real-Time Threat Scanning</h3>
				<p>Automatically detect malware, ransomware, and malicious content the moment it's shared — before it ever reaches your users.</p>
			</div>

			<div class="feature-card">
				<div class="feature-icon compliance-icon">
					<i class="far fa-clipboard-check"></i>
				</div>
				<h3>DLP & Compliance</h3>
				<p>Prevent sensitive data leaks with built-in data loss prevention policies and stay compliant with GDPR, HIPAA, and industry regulations.</p>
			</div>

			<div class="feature-card">
				<div class="feature-icon visibility-icon">
					<i class="fas fa-eye"></i>
				</div>
				<h3>Complete Visibility</h3>
				<p>Get detailed insights into file sharing activities, external access patterns, and potential security risks across your entire organization.</p>
			</div>
		</div>

		<!-- Highlight Section -->
		<div class="highlight-section">
			<div class="highlight-content">
				<div class="highlight-badge">
					<i class="far fa-bolt"></i>
					<span>REAL-TIME</span>
				</div>
				<h2>Automated Threat Response</h2>
				<ul class="highlight-features-list">
					<li>
						<i class="far fa-check-circle"></i>
						<span>Scan all files and links shared in Teams instantly</span>
					</li>
					<li>
						<i class="far fa-check-circle"></i>
						<span>Block malicious content before it reaches your users</span>
					</li>
					<li>
						<i class="far fa-check-circle"></i>
						<span>Monitor SharePoint and OneDrive for threats 24/7</span>
					</li>
					<li>
						<i class="far fa-check-circle"></i>
						<span>Automated quarantine and incident response workflows</span>
					</li>
				</ul>
			</div>
			<div class="highlight-visual">
				<div class="security-card">
					<div class="security-card-header">
						<i class="fas fa-shield-alt"></i>
						<span>Security Monitor</span>
					</div>
					<div class="security-card-body">
						<div class="scan-indicator">
							<span></span><span></span><span></span>
						</div>
						<p>Scanning shared file for threats in Microsoft Teams...</p>
					</div>
				</div>
			</div>
		</div>

		<!-- Bottom CTA -->
		<div class="trial-bottom-cta cursor-pointer"
			 (click)="startFreeTrial()">
			<div class="trial-cta-btn large flex-row gap-2 align-items-center text-white">
				<ng-container *ngIf="!startingTrial">
					<i class="far fa-rocket"></i>
					<span>Start Free 7-Day Trial</span>
				</ng-container>
				<div class="loading-spinner" style="border-color: white; height: 30px; width: 30px;" *ngIf="startingTrial"></div>
			</div>
			<p class="trial-contact-note">
				Have questions?
				<a class="blue-link" [routerLink]="['/' + dic.CONSTANTS.appStates.accountDetails, dic.CONSTANTS.supportPages.tickets]" [state]="{ data: 'open' }">
					Contact our team
				</a>
			</p>
		</div>
	</div>
</div>
